import { make } from './Stack.gen'
import type { align as Align } from './Stack.gen'

type StackProps = React.ComponentProps<typeof make>

const Stack = make as React.ForwardRefExoticComponent<
  React.PropsWithoutRef<StackProps> & React.RefAttributes<HTMLDivElement>
>

export { Stack, type StackProps, type Align }
